<template>
    <div class="item_sidebar shadow-prop" :class="{'active': moreFields}">
	    <div class="wrapper_title" :class="{'mb_0': !moreFields}">
		    <div class="title">{{ title }}</div>

		    <!-- <label class="switch_checkbox_item">
			    <input type="checkbox" @change="showMore" :checked="moreFields">
			    <div class="switch_checkbox"><span></span></div>
		    </label> -->
            <a class="sidebar_item_open_arrow" :class="{'active':moreFields}" @click="moreFieldsToggle">
                <img src="@/modules/page-editor/src/assets/img/chevron-up.svg" alt="">
            </a>
	    </div>
        <div class="wrapper_body wrapper_body_block">

            <div class="item">
                <div class="field margin_top_side w_100">
                  <div class="title">Angle</div>

	                <angle-selector :angle='value.angle||0' @change="updatedData($event, 'angle')" />
	                <div class="flex"></div>
	                <input-field min="0" max="360" step="10" v-model.number="value.angle"
	                             @change="updatedData($event, 'angle')" append="°" small type="number" />
                </div>
            </div>
            <div class="item">
                <div class="field margin_top_side w_100">
                  <div class="title">Distance</div>
	                <input-field min="0" max="500" step="1" v-model.number="value.distance"
	                             @change="updatedData($event, 'distance')" append="px" small type="number" />
                </div>
            </div>
	        <div class="item" v-if="title !== 'Text shadow'">
		        <div class="field margin_top_side w_100">
			        <div class="title">Size</div>
			        <input-field min="0" max="500" step="1" v-model.number="value.spread"
			                     @change="updatedData($event, 'spread')" append="px" small type="number" />
		        </div>
	        </div>
          <div class="item">
              <div class="field margin_top_side w_100">
                <div class="title">Blur</div>
                <input-field min="0" max="500" step="1" v-model.number="value.blur"
                             @change="updatedData($event, 'blur')" append="px" small type="number" />
              </div>
          </div>

            <colorPicker :value="value.color" title="Color" replacedClass="item" @updated="updatedData($event, 'color')" />

            <div class="item" v-if="title !== 'Text shadow'">
                <div class="title">Type</div>
                <form action="#" class="radio_form radio_form_no_m_b">
                    <div class="item">
                        <input type="radio" id="test3" name="radio-group_2" value="" v-model="value.type" @change="updatedData($event.target.value, 'type')">
                        <label for="test3">Outer</label>
                    </div>
                    <div class="item">
                        <input type="radio" id="test4" name="radio-group_2" value="inset" v-model="value.type" @change="updatedData($event.target.value, 'type')">
                        <label for="test4">Inner</label>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import colorPicker from "@/modules/page-editor/src/components/sidebar/sidebar-items/colorPicker.vue"
import InputField from '@/components/base/input-field';
import AngleSelector from '../../base/angle-selector'

export default {
    name: 'ShadowsInput',
    components: {
      colorPicker,
	    InputField,
	    AngleSelector
    },
    props: ['title', 'value'],
    data: function(){
        return {
	        moreFields: false,
	        shadowsData: {
                angle: 0,
                distance: 0,
                blur: 0,
                spread: 0,
                color: 'transparent',
                type: ''
            },
        }
    },
    methods: {
        moreFieldsToggle(){
            this.moreFields = !this.moreFields;
            this.showMore();

            localStorage.setItem(this.title, this.moreFields);
        },
	    showMore(ev) {
		    // this.moreFields = ev.target.checked
		    if (!this.moreFields) {
			    this.shadowsData = {
				    angle: 0,
				    distance: 0,
				    blur: 0,
				    spread: 0,
				    color: 'transparent',
				    type: ''
			    };

			    this.updatedData();
		    }
	    },
        updatedData(val, fieldName){
            if((fieldName == 'angle') || (fieldName == 'distance') || (fieldName == 'blur') || (fieldName == 'spread')) {
                this.shadowsData[fieldName] = +val;
            } else {
                this.shadowsData[fieldName] = val;
            }

            if(this.shadowsData.blur < 0) this.shadowsData.blur = 0;
            if(this.shadowsData.spread < 0) this.shadowsData.spread = 0;

            this.$emit('updated', this.shadowsData);
        },
        numberMinus(name){
            this.shadowsData[name] -= 1;
            this.updatedData();
        },
        numberPlus(name){
            this.shadowsData[name] += 1;
            this.updatedData();
        },
    },
    created(){
      this.shadowsData = JSON.parse(JSON.stringify(this.value));

	    if (this.shadowsData.color && this.shadowsData.color!=='transparent' && this.shadowsData.color!=='#00000000' ) {
		    this.moreFields = true;
	    }
    },
    mounted(){
        if(localStorage.getItem(this.title) !== null) {
            if(localStorage.getItem(this.title) === 'true') {
                this.moreFields = true;
            } else {
                this.moreFields = false;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.title {
	font-weight: 500;
}
</style>
